import React from 'react';

const FaceBook = ({
  fillColor = 'primary',
  className = '',
  id = 'faceBookIcon',
}) => {
  return (
    <svg
      id={id}
      className={`fill-${fillColor} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
    >
      <path d="M42 21.1283C42 9.45947 32.598 0 21 0C9.40201 0 0 9.45947 0 21.1283C0 31.6739 7.67936 40.415 17.7188 42V27.2357H12.3867V21.1283H17.7188V16.4735C17.7188 11.1782 20.854 8.25326 25.6508 8.25326C27.9476 8.25326 30.3516 8.66592 30.3516 8.66592V13.8655H27.7036C25.095 13.8655 24.2812 15.4943 24.2812 17.1668V21.1283H30.1055L29.1744 27.2357H24.2812V42C34.3206 40.415 42 31.6739 42 21.1283Z" />
    </svg>
  );
};
export default FaceBook;
